export const MIN_PRODUCT_VARIANTS = 3;
export const CAROUSEL_SLIDE_SPACING = 'xsmall';
export const CAROUSEL_LABELS_FALLBACK = {
    NEXT: 'Next',
    PREV: 'Previous',
};
//# sourceMappingURL=constants.js.map